var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBtnBack = function SvgBtnBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.5H9.9l2.5-2.4c.1-.2.1-.6 0-.8a.5.5 0 00-.8 0l-3.2 3.3c-.2.2-.2.6 0 .7l3.3 3.3a.5.5 0 10.7-.7l-2.5-2.4h5.6c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
  })));
};
export default SvgBtnBack;